<script context="module" lang="ts">
	let globalLabels: any

	export function setLabels(labels: any) {
		globalLabels = labels
	}
</script>

<script lang="ts">
	import { createEventDispatcher, getContext } from 'svelte'
	const dispatch = createEventDispatcher()
	const stateContext = getContext('state')

	export let dir = 'none'
	export let key: any
	export let labels = {
		// asc: { title: 'Ascending', html: '&#8593;' },
		// desc: { title: 'Desceding', html: '&#8595;' },
		// unsorted: { title: 'Unsorted', html: '&#8645;' },
		asc: { title: 'Ascending', html: '&#8648;' },
		desc: { title: 'Desceding', html: '&#8650;' },
		// asc: { title: 'Ascending', html: '&#8657;' },
		// desc: { title: 'Desceding', html: '&#8659;' },
		unsorted: { title: 'Unsorted', html: '&#8645;' },
		...globalLabels
	}
	export let size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md'

	let fontSize = 16
	let direction = dir
	$: direction = dir

	$: {
		if (size === 'xs') fontSize = 12
		else if (size === 'sm') fontSize = 16
		else if (size === 'lg') fontSize = 26
		else if (size === 'xl') fontSize = 32
		else fontSize = 20 // md
	}

	function onClick(event: any) {
		const state = stateContext.getState()
		let rows

		const detail = {
			originalEvent: event,
			key,
			dir: dir !== 'desc' ? 'desc' : 'asc',
			rows: state.filteredRows
		}

		dispatch('sort', detail)

		// if (detail.preventDefault !== true) {
		if (event.preventDefault !== true) {
			dir = detail.dir
		}
		stateContext.setRows(detail.rows)
	}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<span class="sort" on:click={onClick}>
	{#if direction === 'asc'}
		<span title={labels.asc.title} style="font-size:{fontSize}px;">
			<!-- eslint-disable-next-line svelte/no-at-html-tags -->
			{@html labels.asc.html}
		</span>
	{:else if direction === 'desc'}
		<span title={labels.desc.title} style="font-size:{fontSize}px;">
			<!-- eslint-disable-next-line svelte/no-at-html-tags -->
			{@html labels.desc.html}
		</span>
	{:else}
		<span title={labels.unsorted.title} style="font-size:{fontSize}px;">
			<!-- eslint-disable-next-line svelte/no-at-html-tags -->
			{@html labels.unsorted.html}
		</span>
	{/if}
</span>

<style>
	.sort {
		/* right: 0; */
		cursor: pointer;
		position: absolute;
		padding: 0 0.25em;
		color: #999;
	}
</style>
